import React from "react";
import Navbar from "../components/common/Navbar";
import NewsComponent from "../components/news/NewsComponent";
import "../styles/news.css";

const News = () => {
  return (
    <div className="news_page">
      <Navbar />
      <NewsComponent />
    </div>
  );
};

export default News;
